import { IonButton } from '@ionic/react';
import { useMemo } from 'react';
import { useMessages } from '../i18n/LanguageProvider';
import { useAppData } from '../state/AppDataProvider';
import { needsInstallHint, readDeviceFacts, type DeviceFacts } from './install-hint';

/**
 * DE: Hinweis für Safari auf iPhone/iPad, die App auf den Home-Bildschirm zu legen; dort löscht
 * Safari die Daten nicht nach einer Woche ohne Nutzung.
 * EN: Hint for Safari on iPhone/iPad to put the app on the home screen; there Safari does not
 * delete the data after a week without use.
 */
export function InstallHint({ device }: { device?: DeviceFacts }) {
  const { data, dispatch } = useAppData();
  const { t } = useMessages();
  const facts = useMemo(() => device ?? readDeviceFacts(), [device]);
  if (data.installHintDismissed || !needsInstallHint(facts)) return null;
  return (
    <section className="app-hint app-install-hint">
      <p>{t.installHint}</p>
      <IonButton
        fill="outline"
        size="small"
        onClick={() => dispatch({ type: 'dismiss-install-hint' })}
      >
        {t.installHintDismiss}
      </IonButton>
    </section>
  );
}
